import { loadAsset } from "../utils/loadAsset";
function loadingFn() {
    return function (Proto, input) {
        // Construct new loader and run extensions
        const loader = new Proto();
        // Go through the urls and load them
        return new Promise((res, reject) => loader.load(input, (data) => { res(data); }, undefined, (error) => reject(new Error(`Could not load ${input}: ${error?.message ?? ''}`))));
    };
}
export function useTextureLoader(proto, url, throwError) {
    if (typeof url === 'undefined')
        return undefined;
    // Use suspense to load async assets and add webgl query string to ensure only webgl related caching
    return loadAsset(loadingFn(), url, throwError, proto);
}
